import { loanRequestsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

export const LOAN_REQUESTS_ACTION_TYPE = {
  SEARCH: 'loanRequests/SEARCH',
  SEARCH_SUCCESS: 'loanRequests/SEARCH_SUCCESS',
  SEARCH_FAILURE: 'loanRequests/SEARCH_FAILURE',
  RESET: 'loanRequests/RESET',
};

const createSearchTokenSource = () => {
  const counter = { value: 0 };

  return () => {
    counter.value += 1;

    return counter.value;
  };
};

const nextSearchToken = createSearchTokenSource();

export const searchLoanRequestGroupsAction = catchAsyncActionError(
  ({ applicationId, filters, skip, take }) =>
    async dispatch => {
      const token = nextSearchToken();

      dispatch({ type: LOAN_REQUESTS_ACTION_TYPE.SEARCH, payload: { token } });

      try {
        const { data } = await loanRequestsApi.searchLoanRequestGroups({
          applicationIds: [applicationId],
          ...filters,
          skip,
          take,
        });

        dispatch({
          type: LOAN_REQUESTS_ACTION_TYPE.SEARCH_SUCCESS,
          payload: {
            token,
            items: data?.items ?? [],
            totalCount: data?.totalCount ?? 0,
          },
        });
      } catch (error) {
        dispatch({ type: LOAN_REQUESTS_ACTION_TYPE.SEARCH_FAILURE, payload: { token } });
        throw error;
      }
    },
);

export const resetLoanRequestsAction = () => ({ type: LOAN_REQUESTS_ACTION_TYPE.RESET });
